import styled from "styled-components";

export const ContainerLoading = styled.div`
    flex: auto;
    width: 100%;
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Container = styled.div`
`;

export const Content = styled.div`
    width: 100%;
`;

export const Groups = styled.div`
    color: var(--colorFontsCardsDashboard);
    padding: 1rem 0;
    width: 100%;
    overflow: auto;

    h3{
        margin: 0 0.5rem;
    }
`

export const TableProducts = styled.table`
    border-collapse: collapse;
    width: 100%;
    font-size: 0.9rem;
    margin: 25px 0;
    color: var(--colorFontsCardsDashboard);

    thead{
            tr{
                background: var(--colorBackgroundCardsDashboard);
                text-align: left;

                th:last-child{
                    text-align: right;
                }
            }
    }

    tbody{
        tr{
            border-bottom: 1px solid #DDD;
            text-align: left;
            

            &:nth-child(even){
                background: #f2f2f2;
            }

            &:last-of-type{
                background: #CCC;
                color: black;
                font-weight: 500;
            }

            td:first-child{

            }

            td:last-child{
                    text-align: right;
            }
        }
    }


    th, td{
        padding: 0.7rem 0.9rem;
      
    } 
`

export const Button = styled.div`
    padding: 0.5rem;
    border-radius: 5px;
    background: #2e9699;
    color: #FFF;
    margin: 1rem auto;
    max-width: 300px;
    cursor: pointer;
    opacity: ${props => props.loadingButton ? 0.5 : 1};
    pointer-events: ${props => props.loadingButton ? 'none' : 'all'};
    text-align: center;
`